import {handleFailedChunk} from '@teemill/common/helpers';

export default {
  path: '/checkout/payment-complete/',
  name: 'PaymentComplete',
  meta: {
    title: 'Payment Processing',
    layout: 'standard',
    shareToHomepage: true,
  },
  component: () =>
    import('./PaymentCompletePage.vue').catch(handleFailedChunk),
};
